import {
	forwardRef,
	PropsWithChildren,
	ReactElement,
	ReactNode,
	Ref
} from "react";
import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { Icon } from "../Icon/Icon";
import styles from "./InlineOptionSelectorPreview.module.less";

export type InlineOptionSelectorPreviewProps = {
	trackingId?: string;
	isLeftAligned: boolean;
	onClick(): void;
	children: ReactNode;
};

export const InlineOptionSelectorPreview = forwardRef(
		(props: PropsWithChildren<InlineOptionSelectorPreviewProps>, ref: Ref<HTMLButtonElement>
	): ReactElement => {
		const {
			onClick,
			trackingId,
			isLeftAligned,
			children
		} = props;

		return (
			<button
				ref={ref}
				className={classNames(
					styles.root,
					{
						[styles.root_leftAligned]: isLeftAligned
					}
				)}
				onClick={onClick}
				type="button"
				{...setTrackingId(trackingId)}
			>
				<div className={styles.content}>
					{ children }
				</div>
				<Icon value="chevron-down" size="small"/>
			</button>
		);
});

InlineOptionSelectorPreview.displayName = "InlineOptionSelectorPreview";